var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-icon-dark",attrs:{"href":"#delete"},on:{"click":function($event){$event.preventDefault();_vm.confirmDeleteUser($event)}}},[_c('i',{staticClass:"fa fa-trash-o"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16dfc45f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/DeleteUser.vue
// module id = Ly/l
// module chunks = 1